import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: .4rem .8rem .6rem 0rem;
  max-width: 100%;
`

export const GridPageUserInfo = styled.div`
  display: grid;
  grid-template-columns: 2.6fr 1.6fr 2.6fr 1.6fr;
  gap: 1.5rem;
  justify-content: space-between;
`

export const GridPageInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 1.5rem;
  justify-content: space-between;
`

export const CustomTextField = styled(TextFieldMui)`
`

export const CustomButton = styled(ButtonMui)`
  width: 10rem;    
  height: 2.2rem;
`
